import React,{useState,useEffect,useRef} from 'react';
import PropTypes from 'prop-types';
import Icon, { IconType } from '../icon/icon';
import './toaste.scss';
import Toast from 'react-bootstrap/Toast';
import Button, { ButtonTheme, ButtonType } from '../button/button';
/**
 * Badge with optional icon. It can be used to list items or to define tags.
 */
const Toaste = (props) => {
  const {
    data, mode,type,delay,button,onActionUrl,onClose
  } = props;

  const [showToast,setShowToast] =useState(true);
  const dataRef = useRef(null);
  const [myButton,setMyButton] =useState(null);
  const toggleCloseToast=()=>{
    if(onClose)
      onClose(false);
    setShowToast(false);
  }
  let cssClass="alert-info";
  if(type=="error")
    cssClass="alert-danger";
  
  useEffect(() => {
    setMyButton(button);
  },[button]);

  useEffect(() => {
    if (dataRef.current) {
      dataRef.current.scrollIntoView({ block: 'end', behavior: 'smooth' });
    }
  }, [data]);
  const onClickAction=()=>{
    let params=(button.actionParams?button.actionParams:null);
    onActionUrl(button.actionUrl,params);
  }
  return (
    <div>
      {mode=="toast" && 
        <Toast onClose={toggleCloseToast} show={showToast} animation={true} delay={delay} autohide
          className={cssClass}
        > 
          <Toast.Header>
            {data && <div className="text">
              {Object.keys(data).map((i) => <div key={`info-${i}`}>{data[i]}</div>)}
              {myButton && <div>
                  <Button  
                      id={myButton.id?myButton.id:'add-panel'}
                      type={ButtonType.BUTTON} 
                      theme={ButtonTheme.INFO} 
                      dataId={(myButton.actionUrl?myButton.actionUrl:'')}
                      onClick={onClickAction}
                  >{myButton.title}
                </Button>
                </div>}
            </div>}
            {!data && <div className="text">no message available</div>}
          </Toast.Header>
        </Toast>}
      {mode=="normal" && <div ref={dataRef} className={"alert "+cssClass} role="alert">
          { Object.keys(data).map((i) => <div key={`error-${i}`}>{data[i]}</div>)}
        </div>
      }
    </div>
  );
};

Toaste.propTypes = {
  /**
   * Text inside the badge
   */
  children: PropTypes.node,
  /**
   * To select a icon inside the badge
   */
  icon: PropTypes.oneOf(Object.values(IconType)),
  /**
   * Function to bind onClick HTML functionality
   */
  onClick: PropTypes.func,
  className: PropTypes.string,
};

Toaste.defaultProps = {
  type: 'info',
  mode: 'toast', //options normal,toast
  delay:30000
};

export default Toaste;
